import { Button, Modal } from 'antd'
import styled from 'styled-components'

export const LeftSection = styled.div`
  min-width: 280px;
  width: 30%;
  min-height: 851px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: var(--color-bg);
  border-radius: 6px;
  border: 1px solid var(--color-border-primary);
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
`

export const CardImage = styled.div<{ $src: string; $clickable?: boolean }>`
  align-self: stretch;
  min-width: 240px;
  min-height: 240px;
  height: 240px;
  max-width: 240px;
  display: flex;
  flex-direction: column;
  padding-top: 13px;
  padding-bottom: 13px;
  padding-left: 12px;
  padding-right: 12px;
  margin-bottom: 12px;
  margin-right: 20px;
  background-image: url(${(props) => props.$src});
  background-size: cover;
  background-position: center;
  border-radius: 6px;
  cursor: ${(props) => (props.$clickable ? 'pointer' : 'default')};
`

export const PopUp = styled(Modal)`
  width: 411px !important;
  background-color: var(--color-bg);
  border-radius: 4px;
`

export const PopUpMessage = styled.div`
  color: var(--color-text-primary);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  width: 90%;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const PopUpButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding-bottom: 20px;
`

export const PopUpButton = styled(Button)`
  width: 89px;
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const CardImageContent = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 154px;
`

export const KiroLogo = styled.img`
  width: 30px;
  height: 30px;
  object-fit: fill;
`

export const AgeBox = styled.div`
  width: 30px;
  height: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: var(--color-bg);
  border-radius: 6px;
  margin-left: auto;
`

export const Text = styled.span<{
  $bold?: boolean
  $size?: number
  $color?: string
  $marginRight?: number
  $marginBottom?: number
  $marginTop?: number
}>`
  color: ${(props) => props.$color || 'var(--color-text-primary)'};
  font-size: ${(props) => props.$size || 16}px;
  font-weight: ${(props) => (props.$bold ? '700' : 'normal')};
  margin-right: ${(props) => (props.$marginRight ? `${props.$marginRight}px` : '0')};
  margin-bottom: ${(props) => (props.$marginBottom ? `${props.$marginBottom}px` : '0')};
  margin-top: ${(props) => (props.$marginTop ? `${props.$marginTop}px` : '0')};
`

export const SourceIdentifier = styled.button<{ $noBorder?: boolean; $bg?: string; $spread?: boolean }>`
  width: 216px;
  height: 30px;
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  /* source on the left, first paid amount on the right */
  justify-content: ${(props) => (props.$spread ? 'space-between' : 'center')};
  padding: ${(props) => (props.$spread ? '0 12px' : '0')};
  background: ${(props) => props.$bg || 'var(--color-bg)'};
  border-radius: 6px;
  border: ${(props) => (props.$noBorder ? 'none' : `1px solid var(--color-border-primary)`)};
  text-align: left;
  box-shadow: ${(props) => (props.$noBorder ? 'none' : 'var(--shadow-box)')};
`

export const NameText = styled.span`
  color: var(--color-text-primary);
  font-size: 20px;
  font-weight: 800;
  margin-right: 132px;
  width: 100%;
  text-transform: capitalize;
`

export const LastNameText = styled.span`
  color: var(--color-text-primary);
  font-size: 20px;
  font-weight: 800;
  margin-top: -6px;
  margin-bottom: 12px;
  width: 100%;
  text-transform: capitalize;
`

export const MetricRow = styled.div`
  align-self: stretch;
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
  margin-right: 20px;
  gap: 8px;
`

export const MetricButton = styled.div`
  width: 58px;
  min-width: 58px;
  max-height: 58px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--color-bg);
  border-radius: 6px;
  border: 1px solid var(--color-border-primary);
  padding-top: 3px;
  padding-left: 13px;
  padding-right: 13px;
  gap: 2px;
  text-align: left;
`

export const ScanBox = styled.div`
  max-height: 58px;
  width: 108px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #ffce00;
  border-radius: 6px;
  border: 1px solid var(--color-border-primary);
  padding-top: 17px;
  padding-bottom: 17px;
  padding-left: 11px;
  padding-right: 11px;
`

export const DateBox = styled(Button)`
  height: 29px;
  min-width: 240px;
  align-self: stretch;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  background: transparent;
  border-radius: 6px;
  border: 1px solid var(--color-border-primary);
  padding-top: 2.5px;
  padding-bottom: 4px;
  padding-left: 12px;
  padding-right: 12px;
  margin-bottom: 118px;
  margin-right: 20px;
`

export const NavigationButtonsContainer = styled.div`
  align-self: stretch;
  display: flex;
  gap: 8px;
  margin-top: auto;
  margin-right: 20px;
`

export const NavigationButton = styled.button<{ $disabled?: boolean }>`
  flex: 1;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => (props.$disabled ? 'var(--color-disabled-bg)' : 'var(--color-bg)')};
  border-radius: 6px;
  border: 1px solid ${(props) => (props.$disabled ? 'var(--color-disabled)' : 'var(--color-border-primary)')};
  color: ${(props) => (props.$disabled ? 'var(--color-disabled)' : 'var(--color-text-primary)')};
  font-size: 20px;
  font-weight: 700;
  box-shadow: var(--shadow-box);
  cursor: ${(props) => (props.$disabled ? 'not-allowed' : 'pointer')};
  transition: 0.2s;
  opacity: ${(props) => (props.$disabled ? 0.5 : 1)};

  &:hover:not(:disabled) {
    background: ${(props) => (props.$disabled ? 'var(--color-disabled-bg)' : 'var(--color-bg)')};
  }

  &:disabled {
    cursor: not-allowed;
  }
`

export const CheckInButton = styled(Button)`
  height: 52px;
  align-self: stretch;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-primary);
  border-radius: 6px;
  border: 1px solid var(--color-primary);
  padding-top: 13px;
  padding-bottom: 13px;
  margin-right: 20px;
  box-shadow: var(--shadow-box);
  text-align: left;
  margin-top: 8px;
`

export const DoneButton = styled.button`
  height: 52px;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: var(--color-primary);
  border-radius: 6px;
  border: 1px solid var(--color-primary);
  padding-top: 13px;
  padding-bottom: 13px;
  margin-right: 20px;
  box-shadow: var(--shadow-box);
  text-align: left;
`
